import request from '@/utils/request'

export function findAgentsProfileProducts(params) {
  return request({
    url: `/agents_profile_products`,
    method: 'get',
    params
  })
}

export function importAgentsProfileProducts(data) {
  return request({
    url: `/agents_profile_products/import`,
    method: 'post',
    data
  })
}

export function findAgentsProfileProductForm(id) {
  return request({
    url: `/agents_profile_products/${id}/form`,
    method: 'get'
  })
}

export function updateAgentsProfileProduct(id, data) {
  return request({
    url: `/agents_profile_products/${id}`,
    method: 'put',
    data
  })
}

export function batchUpdateAgentsProfileProductsEffective(ids, effective) {
  return request({
    url: `/agents_profile_products/effective/batch`,
    method: 'patch',
    data: { ids, effective }
  })
}
